import { useState, useEffect } from 'react';
import { APIDeleteAccessId, APIPostAccessId } from '../../api/access/Access';
import { FaRegCopy } from "react-icons/fa";

export const LinkShare = ({accessData, setAccessData, entityId, entityType}) => {
    const [ id, setId ] = useState(null);
    const [ accessId, setAccessId ] = useState(null);

    const generateLink = async () => {
        const accessLink = await APIPostAccessId(entityId, entityType)
        if (accessLink) {
            setAccessData({
                id: accessLink.id,
                access_id: accessLink.accessId,
            });
        }
    }

    const deleteLink = async () => {
        await APIDeleteAccessId(id)
        setAccessData(null);
        setId(null);
        setAccessId(null);
    }

    useEffect(() => {
        if (accessData) {
            setId(accessData.id);
            setAccessId(accessData.access_id);
        } else {
            setId(null);
            setAccessId(null);
        }
    }, [accessData]);


    return (
        <div className="flex flex-col gap-4">
            {id ? (
                <>
                    <h2 className="text-xl font-bold text-gray-800 mb-2">Link zu Ihrem Plan</h2>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">
                        Hier ist der Link zu Ihrem Plan. Sie können ihn kopieren und mit anderen teilen.
                    </p>
                    <div className="flex items-center gap-2">
                        <input
                            type="text"
                            value={`https://app.xplanung24.de/linkshare/${accessId}`}
                            readOnly
                            className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm text-gray-700"
                        />
                        <button
                            type="button"
                            className="bg-gray-600 text-white rounded-md px-4 py-2 text-sm font-semibold"
                            onClick={() => navigator.clipboard.writeText(`https://app.xplanung24.de/linkshare/${accessId}`)}
                        >
                            <FaRegCopy className="inline-block" />
                        </button>
                    </div>
                    <p className="text-gray-500 text-sm mt-2">
                        Hinweis: Der Link bleibt aktiv, bis Sie ihn löschen.
                    </p>
                    <button
                    type="button"
                    className="self-end w-40 text-center truncate items-center rounded-md bg-red/80 border-2 px-2 py-2 text-sm font-semibold text-white"
                    onClick={deleteLink}
                    >
                        Link löschen
                    </button>
                </>
            ) : (
                <>
                    <h2 className="text-xl font-bold text-gray-800 mb-2">Plan via Link teilen</h2>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">
                        Hier können Sie Ihren privaten Plan über einen öffentlichen Link freigeben. Jeder, der diesen Link besitzt, kann den Plan einsehen – auch ohne Anmeldung.<br />
                        <span className="block mt-2 text-gray-500 italic">
                            Hinweis: Der Plan bleibt privat, solange Sie keinen Link erstellen oder weitergeben. Wenn Sie den Link später löschen, ist der Plan darüber nicht mehr aufrufbar.
                        </span>
                    </p>
                    <button
                        type="button"
                        className="self-end w-40 text-center truncate items-center rounded-md bg-white border-gray-600 border-2 px-2 py-2 text-sm font-semibold text-gray-600"
                        onClick={generateLink}
                    >
                        Link generieren
                    </button>
                </>       
            )}
        </div>
    );
}
